export function getLanguageString(input: string): string {
	var inputIso6393 = input.split('-');

	if (inputIso6393[0]) {
		return inputIso6393[0].toLowerCase();
	}
	return 'en';
}
